import {
  AssignmentEntityType,
  BulkAssignmentEntity,
  IGetOrganizationUsersParams,
} from "../types";

export const buildOrganizationUsersParams = ({
  entityType,
  entity,
  pageNo,
  searchQuery,
}: {
  entityType: AssignmentEntityType;
  entity: BulkAssignmentEntity;
  pageNo: number;
  searchQuery: string;
}): IGetOrganizationUsersParams => {
  const params: IGetOrganizationUsersParams = {
    page_no: pageNo,
  };

  switch (entityType) {
    case "DEPARTMENT":
      params.department_id = entity.public_id;
      break;
    case "COST_CENTER":
      params.cost_center_id = entity.public_id;
      break;
    case "EMPLOYEE_GRADE":
      params.employee_grade_id = entity.public_id;
      break;
  }

  const search = searchQuery.trim();
  if (search) {
    params.search = search;
  }

  return params;
};
